export enum Role {
  Administrador = 'Administrador',
  Monitorista = 'Monitorista',
  Mantenimiento = 'Mantenimiento',
  Soporte = 'Soporte',
  Operativo = 'Operativo'
}

export class Route {
  id: string
  icon: string
  title: string
  path: string
  children?: SubRoute[]
  active?: boolean

  constructor(id: string, icon: string, title: string, path: string, children?: SubRoute[]) {
    this.id = id
    this.icon = icon
    this.title = title
    this.path = path
    this.children = children
    this.active = false
  }

  static fromObject(item: any): Route {
    let children

    if (item.children) {
      children = []

      for (const child of item.children) {
        children.push(SubRoute.fromObject(child))
      }
    }

    return new Route(item.id, item.icon, item.title, item.path, item.children)
  }
}

export class SubRoute {
  icon: null
  title: string
  path: string
  children?: SubRoute[]
  active: boolean

  constructor(title: string, path: string, children?: SubRoute[]) {
    this.title = title
    this.path = path
    this.children = children
    this.icon = null
    this.active = false
  }

  static fromObject(item: any): SubRoute {
    let children

    if (item.children) {
      children = []

      for (const child of item.children) {
        children.push(SubRoute.fromObject(child))
      }
    }

    return new SubRoute(item.title, item.path, children)
  }
}